// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__OYoYH","footerContainer":"Footer_footerContainer__1Dvy2","copyRight":"Footer_copyRight__08aoz"};